var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useState, useMemo } from "react";
import styled from "styled-components";
import { Icon } from "../../../icon";
import Flex from "../../../templates/flex";
import { LayoutContext } from "../../layout-context";
var StyledColumnHead = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    opacity: 0.7;\n  }\n"], ["\n  &:hover {\n    opacity: 0.7;\n  }\n"])));
export var ColumnHead = function (_a) {
    var column = _a.column, sortableBy = _a.sortableBy, customProps = _a.customProps;
    var _b = useState(false), hover = _b[0], setHover = _b[1];
    var layoutType = useContext(LayoutContext);
    var id = column.id, getSortByToggleProps = column.getSortByToggleProps, getHeaderProps = column.getHeaderProps, render = column.render, isSorted = column.isSorted, isSortedDesc = column.isSortedDesc;
    var isColumnSortable = sortableBy.includes(id);
    var showHoverIndicator = isColumnSortable && hover;
    var sortProps = useMemo(function () { return (isColumnSortable ? getSortByToggleProps() : {}); }, [
        isColumnSortable,
    ]);
    return layoutType === "table" ? (React.createElement("th", __assign({}, sortProps, getHeaderProps(), { onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }), isColumnSortable ? (React.createElement(StyledColumnHead, { alignItems: "center", justifyContent: "start", height: { min: 6 }, gap: 2 },
        render("Header", __assign({}, customProps)),
        isSorted ? (React.createElement(Icon, { name: "arrow_s_down", color: "text", width: "10", height: "10", rotate: isSortedDesc ? null : 2, "data-testid": "columnHhead-sortingIcon" })) : (showHoverIndicator && (React.createElement(Icon, { name: "arrow_s_down", color: "text", width: "10", height: "10", rotate: 2 }))))) : (render("Header", __assign({}, customProps))))) : (React.createElement("div", __assign({}, sortProps, getHeaderProps(), { className: "column-head" }), render("Header", __assign({}, customProps))));
};
var templateObject_1;
